import { apiConstants } from "../../shared/config";
import work from './type';
const code = apiConstants.code;
const baseRouteName = `${code}.${work.key}_`;


const authAccess = { roles: ['GIM_22000'], redirect: { name: 'portal.login' }, forbiddenRedirect: '/portal/acesso-negado' };

export const type = work.key;
export const routes = {
    path: `/${code}/${work.basePath}`,
    component: () => import ( /* webpackChunkName: "gimgestao-municipal_works" */ './views/MunicipalWorksBase.vue'),
    children: [
        {
            path: `home`,
            name: `${code}.${work.basePath}.home`,
            component: () => import ( /* webpackChunkName: "gimgestao" */ './views/Home.vue'),
            meta: {
                auth: undefined,
                hideHeaderName: true,
                title: 'Home',
            }
        },
        {
            path: `status`,
            component: () => import( /* webpackChunkName: "gimgestao-municipal_works" */ './views/status/StatusBase.vue'),
            children: [
                {
                    path: '/',
                    name: `${baseRouteName}statuses`,
                    component: () => import( /* webpackChunkName: "gimgestao-municipal_works" */ './views/status/StatusList.vue'),
                    meta: {
                        auth: undefined,
                        hideHeaderName: true,
                        title: 'Estados',
                    }
                },
                {
                    path: 'add',
                    name: `${baseRouteName}statuses.create`,
                    props: true,
                    component: () => import( /* webpackChunkName: "gimgestao-municipal_works" */ './views/status/StatusDetails.vue'),
                    meta: {
                        auth: undefined,
                        hideHeaderName: true,
                        title: 'Estado',
                    }
                },
                {
                    path: ':id',
                    name: `${baseRouteName}statuses.show`,
                    props: true,
                    component: () => import( /* webpackChunkName: "gimgestao-municipal_works" */ './views/status/StatusDetails.vue'),
                    meta: {
                        auth: undefined,
                        hideHeaderName: true,
                        title: 'Estado',
                    }
                },
            ],
            meta: {
                auth: undefined,
                hideHeaderName: true,
                title: 'Estado',
            }
        },
        {
            path: `type`,
            component: () => import( /* webpackChunkName: "gimgestao-municipal_works" */ './views/type/TypeBase.vue'),
            children: [
                {
                    path: '/',
                    name: `${baseRouteName}types`,
                    component: () => import( /* webpackChunkName: "gimgestao-municipal_works" */ './views/type/TypeList.vue'),
                    meta: {
                        auth: undefined,
                        hideHeaderName: true,
                        title: 'Tipos',
                    }
                },
                {
                    path: 'add',
                    name: `${baseRouteName}types.create`,
                    props: true,
                    component: () => import( /* webpackChunkName: "gimgestao-municipal_works" */ './views/type/TypeDetails.vue'),
                    meta: {
                        auth: undefined,
                        hideHeaderName: true,
                        title: 'Tipo',
                    }
                },
                {
                    path: ':id',
                    name: `${baseRouteName}types.show`,
                    props: true,
                    component: () => import( /* webpackChunkName: "gimgestao-municipal_works" */ './views/type/TypeDetails.vue'),
                    meta: {
                        auth: undefined,
                        hideHeaderName: true,
                        title: 'Tipo',
                    }
                },
            ],
            meta: {
                auth: undefined,
                hideHeaderName: true,
                title: 'Tipo',
            }
        },
        {
            path: `applicant`,
            component: () => import( /* webpackChunkName: "gimgestao-municipal_works" */ './views/applicant/ApplicantBase.vue'),
            children: [
                {
                    path: '/',
                    name: `${baseRouteName}applicants`,
                    component: () => import( /* webpackChunkName: "gimgestao-municipal_works" */ './views/applicant/ApplicantList.vue'),
                    meta: {
                        auth: undefined,
                        hideHeaderName: true,
                        title: 'Requerentes',
                    }
                },
                {
                    path: 'add',
                    name: `${baseRouteName}applicants.create`,
                    props: true,
                    component: () => import( /* webpackChunkName: "gimgestao-municipal_works" */ './views/applicant/ApplicantDetails.vue'),
                    meta: {
                        auth: undefined,
                        hideHeaderName: true,
                        title: 'Requerente',
                    }
                },
                {
                    path: ':id',
                    name: `${baseRouteName}applicants.show`,
                    props: true,
                    component: () => import( /* webpackChunkName: "gimgestao-municipal_works" */ './views/applicant/ApplicantDetails.vue'),
                    meta: {
                        auth: undefined,
                        hideHeaderName: true,
                        title: 'Requerente',
                    }
                },
            ],
            meta: {
                auth: undefined,
                hideHeaderName: true,
                title: 'Requerente',
            }
        },
        {
            path: `type_global`,
            component: () => import( /* webpackChunkName: "gimgestao-type" */ './views/typeGlobal/TypeBase.vue'),
            children: [
                {
                    path: '/',
                    name: `${baseRouteName}type_global`,
                    component: () => import( /* webpackChunkName: "gimgestao-type" */ './views/typeGlobal/TypeList.vue'),
                    meta: {
                        auth: undefined,
                        hideHeaderName: true,
                        title: 'Tipos Global',
                    }
                },
                {
                    path: 'add',
                    name: `${baseRouteName}type_global.create`,
                    props: true,
                    component: () => import( /* webpackChunkName: "gimgestao-type" */ './views/typeGlobal/TypeDetails.vue'),
                    meta: {
                        auth: undefined,
                        hideHeaderName: true,
                        title: 'Tipo Global',
                    }
                },
                {
                    path: ':id',
                    name: `${baseRouteName}type_global.show`,
                    props: true,
                    component: () => import( /* webpackChunkName: "gimgestao-type" */ './views/typeGlobal/TypeDetails.vue'),
                    meta: {
                        auth: undefined,
                        hideHeaderName: true,
                        title: 'Tipo Global',
                    }
                },
            ],
            meta: {
                auth: undefined,
                hideHeaderName: true,
                title: 'Tipo Global',
            }
        },
        {
            path: `status_global`,
            component: () => import( /* webpackChunkName: "gimgestao-status" */ './views/statusGlobal/StatusBase.vue'),
            children: [
                {
                    path: '/',
                    name: `${baseRouteName}status_global`,
                    component: () => import( /* webpackChunkName: "gimgestao-status" */ './views/statusGlobal/StatusList.vue'),
                    meta: {
                        auth: undefined,
                        hideHeaderName: true,
                        title: 'Estados Global',
                    }
                },
                {
                    path: 'add',
                    name: `${baseRouteName}status_global.create`,
                    props: true,
                    component: () => import( /* webpackChunkName: "gimgestao-status" */ './views/statusGlobal/StatusDetails.vue'),
                    meta: {
                        auth: undefined,
                        hideHeaderName: true,
                        title: 'Estado Global',
                    }
                },
                {
                    path: ':id',
                    name: `${baseRouteName}status_global.show`,
                    props: true,
                    component: () => import( /* webpackChunkName: "gimgestao-status" */ './views/statusGlobal/StatusDetails.vue'),
                    meta: {
                        auth: undefined,
                        hideHeaderName: true,
                        title: 'Estado Global',
                    }
                },
            ],
            meta: {
                auth: undefined,
                hideHeaderName: true,
                title: 'Estado Global',
            }
        },
    ],
    meta: {
        auth: undefined,
        hideHeaderName: true,
        title: 'Obras Municipais',
    }
};

export default routes;
